/**
 * Canonical Featured Projects list from Studio13 season inventory.
 * Order in this array is display order (newest → oldest).
 * Within Global City Dammam: Rasha Rizk Concert → Howling → The Dark → Dart Zone → Karting.
 * sortKey is metadata only — do not re-sort descending (that reverses within-season order).
 */
export const FEATURED_PROJECTS = [
  // SAF (Sound Of Abha) — May 2026 – Present
  {
    id: 'pubg-saf',
    title: 'Pubg',
    description: 'PUBG-themed immersive experience at Sound of Abha.',
    year: '2026 – Present',
    cityOrSeason: 'SAF (Sound Of Abha)',
    slug: 'pubg-saf',
    match: (t) => {
      const title = String(t || '').trim();
      if (/pubg\s*mobile/i.test(title)) return false;
      return (
        /^pubg$/i.test(title) ||
        /pubg.*abha|abha.*pubg|sound\s+of\s+abha.*pubg|\bsaf\b.*pubg|pubg.*\bsaf\b/i.test(title)
      );
    },
    sortKey: 20260501,
  },
  {
    id: 'aliens-vs-monsters',
    title: 'Aliens vs Monsters',
    description: 'An epic battle experience at Sound of Abha.',
    year: '2026 – Present',
    cityOrSeason: 'SAF (Sound Of Abha)',
    slug: 'aliens-vs-monsters',
    match: (t) => /aliens?\s+vs\s+monsters?/i.test(t),
    sortKey: 20260502,
  },
  {
    id: 'toots',
    title: 'Toots',
    description: 'Immersive family attraction at Sound of Abha.',
    year: '2026 – Present',
    cityOrSeason: 'SAF (Sound Of Abha)',
    slug: 'toots',
    match: (t) => /\btoots?\b/i.test(t),
    sortKey: 20260503,
  },

  // 2025 Dammam — Global City (Oct 2025 – May 2026)
  // Global City Dammam order: Rasha Rizk Concert → Howling → The Dark → Dart Zone → Karting
  {
    id: 'rasha-rizk',
    title: 'Rasha Rizk',
    description: 'Live concert experience at Global City, Dammam.',
    year: '2025',
    cityOrSeason: 'Global City, 2025 Dammam',
    slug: 'rasha-rizk',
    match: (t) => /rasha\s*riz[kq]/i.test(t),
    sortKey: 20251001,
  },
  {
    id: 'howling',
    title: 'Howling',
    description: 'Immersive horror experience at Global City, Dammam.',
    year: '2025',
    cityOrSeason: 'Global City, 2025 Dammam',
    slug: 'howling',
    match: (t) => /howling/i.test(t),
    sortKey: 20251002,
  },
  {
    id: 'the-dark',
    title: 'The Dark',
    description: 'Immersive dark-experience attraction at Global City, Dammam.',
    year: '2025',
    cityOrSeason: 'Global City, 2025 Dammam',
    slug: 'the-dark',
    match: (t) => /the\s+dark/i.test(t),
    sortKey: 20251003,
  },
  {
    id: 'dart-zone',
    title: 'Dart Zone',
    description: 'Action-packed tactical battle experience in Global City.',
    year: '2025',
    cityOrSeason: 'Global City, 2025 Dammam',
    slug: 'dart-zone',
    match: (t) => /dart\s*zone/i.test(t),
    sortKey: 20251004,
  },
  {
    id: 'karting',
    title: 'Karting',
    description: 'High-speed karting attraction at Global City, Dammam.',
    year: '2025',
    cityOrSeason: 'Global City, 2025 Dammam',
    slug: 'karting',
    match: (t) => /karting|go[\s-]?kart/i.test(t),
    sortKey: 20251005,
  },

  // 2025 Riyadh Season (Sep 2025 – May 2026)
  {
    id: 'pubg-mobile',
    title: 'PUBG Mobile',
    description: 'An immersive horror experience set in the PUBG Mobile universe.',
    year: '2025',
    cityOrSeason: 'BLVD World, 2025 Riyadh Season',
    slug: 'pubg-mobile',
    match: (t) => {
      const title = String(t || '').trim();
      if (/abha|\bsaf\b/i.test(title) && !/pubg\s*mobile/i.test(title)) return false;
      return /pubg\s*mobile/i.test(title);
    },
    sortKey: 20250901,
  },
  {
    id: 'midnight-manor',
    title: 'Midnight Manor',
    description: 'Immersive horror manor experience at BLVD World.',
    year: '2025',
    cityOrSeason: 'BLVD World, 2025 Riyadh Season',
    slug: 'midnight-manor',
    match: (t) => /midnight\s+manor/i.test(t),
    sortKey: 20250902,
  },
  {
    id: 'poppy-playtime',
    title: 'Poppy Playtime',
    description: 'Immersive Poppy Playtime attraction at BLVD City.',
    year: '2025',
    cityOrSeason: 'BLVD City, 2025 Riyadh Season',
    slug: 'poppy-playtime',
    match: (t) => /poppy\s*playtime/i.test(t),
    sortKey: 20250903,
  },

  // 2025 Jeddah Season (Mar 2025 – Jun 2025)
  {
    id: 'music-hell',
    title: 'Music Hell',
    description: 'A thrilling horror-themed musical experience.',
    year: '2025',
    cityOrSeason: 'City Walk, 2025 Jeddah Season',
    slug: 'music-hell',
    match: (t) => /music\s+hell/i.test(t),
    sortKey: 20250301,
  },
  {
    id: 'lucastar',
    title: 'Lucastar',
    description: 'Magical entertainment attraction at Wonder Forest.',
    year: '2025',
    cityOrSeason: 'Wonder Forest, 2025 Jeddah Season',
    slug: 'lucastar',
    match: (t) => /lucastar/i.test(t),
    sortKey: 20250302,
  },

  // 2024 Riyadh Season (Jun 2024 – Apr 2025)
  {
    id: 'deadzone',
    title: 'Dead Zone',
    description: 'High-intensity immersive experience at BLVD Runway.',
    year: '2024',
    cityOrSeason: 'BLVD Runway, 2024 Riyadh Season',
    slug: 'deadzone',
    match: (t) => /dead\s*zone|deadzone/i.test(t),
    sortKey: 20240601,
  },
  {
    id: 'skywar',
    title: 'Skywar',
    description: 'Aerial battle immersive experience at BLVD Runway.',
    year: '2024',
    cityOrSeason: 'BLVD Runway, 2024 Riyadh Season',
    slug: 'skywar',
    match: (t) => /sky\s*war|skywar|sky\s*siege/i.test(t),
    sortKey: 20240602,
  },
  {
    id: 'a-lot-like-life',
    title: 'Alot Like Life',
    description: 'A realistic horror experience that mirrors everyday life.',
    year: '2024',
    cityOrSeason: 'BLVD City, 2024 Riyadh Season',
    slug: 'a-lot-like-life',
    match: (t) => /a\s*lot\s+like\s+life/i.test(t),
    sortKey: 20240603,
  },
  {
    id: 'curse-of-the-nile',
    title: 'Curse of the Nile',
    description: 'Ancient-curse immersive horror at BLVD World.',
    year: '2024',
    cityOrSeason: 'BLVD World, 2024 Riyadh Season',
    slug: 'curse-of-the-nile',
    match: (t) => /curse\s+of\s+the\s+nile/i.test(t),
    sortKey: 20240604,
  },
  {
    id: 'vampire-hotel',
    title: 'Vampire Hotel',
    description: 'Gothic horror hotel experience at BLVD World.',
    year: '2024',
    cityOrSeason: 'BLVD World, 2024 Riyadh Season',
    slug: 'vampire-hotel',
    match: (t) => /vampire\s+hotel/i.test(t),
    sortKey: 20240605,
  },
  {
    id: 'luca-park',
    title: 'Luca Park',
    description: 'Themed family amusement park experience at The Groves.',
    year: '2024',
    cityOrSeason: 'The Groves, 2024 Riyadh Season',
    slug: 'luca-park',
    match: (t) => /luca\s*park/i.test(t),
    sortKey: 20240606,
  },

  // 2024 Jeddah Season
  {
    id: 'locanda',
    title: 'Locanda of Happiness',
    description: 'Immersive experience at City Walk, Jeddah Season.',
    year: '2024',
    cityOrSeason: 'City Walk, 2024 Jeddah Season',
    slug: 'locanda',
    match: (t) => /\blocanda\b/i.test(t),
    sortKey: 20240201,
  },

  // 2023 Riyadh Season (Jun 2023 – Mar 2024)
  {
    id: 'mummy-quest',
    title: 'Mummy Quest',
    description: 'Immersive mummy adventure walkthrough at BLVD World.',
    year: '2023',
    cityOrSeason: 'BLVD World, 2023 Riyadh Season',
    slug: 'mummy-quest',
    match: (t) => /mummy/i.test(t),
    sortKey: 20230601,
  },
  {
    id: 'hotel-of-terror',
    title: 'Hotel of Terror',
    description: 'Classic haunted-hotel horror at BLVD World.',
    year: '2023',
    cityOrSeason: 'BLVD World, 2023 Riyadh Season',
    slug: 'italian-hotel',
    match: (t) => /hotel\s+of\s+terror|albergo|italian\s+hotel|terrore/i.test(t),
    sortKey: 20230602,
  },

  // 2023 Jeddah Season
  {
    id: 'horror-movie-house',
    title: 'Horror Movie House',
    description: 'Cinematic horror walk-through experience.',
    year: '2023',
    cityOrSeason: 'City Walk, 2023 Jeddah Season',
    slug: 'horror-movie-house',
    match: (t) => /horror\s+movie\s+house/i.test(t),
    sortKey: 20230301,
  },
  {
    id: 'fnaf',
    title: "Five Nights at Freddy's",
    description:
      "A real-life visual experience inspired by the eerie atmosphere of Five Nights at Freddy's.",
    year: '2023',
    cityOrSeason: 'City Walk, 2023 Jeddah Season',
    slug: 'fnaf',
    match: (t) => /five\s+nights|\bfnaf\b|freddy/i.test(t),
    sortKey: 20230302,
  },

  // 2022 Jeddah
  {
    id: 'horrorcon',
    title: 'HorrorCon',
    description:
      'Horror convention experience at Le Prestige Mall, Jeddah — 2022.',
    year: '2022',
    cityOrSeason: 'Le Prestige Mall, Jeddah',
    slug: 'horrorcon',
    match: (t) => /horror\s*con|horrorcon/i.test(t),
    sortKey: 20220201,
  },
  {
    id: 'selfie-studio',
    title: 'Selfie Studio',
    description: 'Interactive photo studio experience at Jeddah Pier.',
    year: '2022',
    cityOrSeason: 'Jeddah Pier, 2022 Jeddah Season',
    slug: 'selfie-studio',
    match: (t) => /selfie\s+studio/i.test(t),
    sortKey: 20220101,
  },
];

/** Find the best Firestore doc for a featured entry (prefer title match). */
export function findFirestoreMatch(featured, firestoreProjects, usedIds = new Set()) {
  const available = firestoreProjects.filter((p) => !usedIds.has(p.id));

  const byTitle = available.find((p) => featured.match(p.title || ''));
  if (byTitle) return byTitle;

  // Slug fallback only when title also fits (keeps Pubg SAF vs PUBG Mobile distinct)
  return (
    available.find(
      (p) =>
        p.slug &&
        featured.slug &&
        String(p.slug).trim() === featured.slug &&
        featured.match(p.title || '')
    ) || null
  );
}
